import React from 'react';

const daysOfTheWeek = [
    { value: "MONDAY",    label: "SEG" },
    { value: "TUESDAY",   label: "TER" },
    { value: "WEDNESDAY", label: "QUA" },
    { value: "THURSDAY",  label: "QUI" },
    { value: "FRIDAY",    label: "SEX" },
    { value: "SATURDAY",  label: "SÁB" },
    { value: "SUNDAY",    label: "DOM" },
];

export const dayMap = Object.fromEntries(daysOfTheWeek.map(d => [d.value, d]));

function DaysOfWeekCellRenderer({ value }) {
    return (
        <div className="flex flex-wrap gap-1 content-center h-full py-1">
            {(value ?? []).map(day => (
                <span key={day} className="text-xs font-medium bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded">
                    {dayMap[day]?.label}
                </span>
            ))}
        </div>
    );
}

export default DaysOfWeekCellRenderer;
